import React, { useContext } from 'react';
import styled from 'styled-components';
import { Header2, Table as BaseTable } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { AccordionSummaryContainer } from '@ubeya/shared-web/components/Accordion/Accordion';
import { RootContainer, RootWrapper } from '../styled';
import AWRWeeksRenderer from './AWRWeeksRenderer';

const Table = styled(BaseTable)`
  height: 202px;
  margin-bottom: 20px;
`;

const EmployeeWorkingTimeDirective = () => {
  const { t } = useContext(ConfigContext);

  const columns = [
    {
      Header: 'Position',
      dataKey: 'position',
      formatter: (value) => <div>{value} </div>
    },

    {
      Header: 'Client',
      dataKey: 'client',
      formatter: (value) => <div>{value} </div>
    },
    {
      Header: 'Calendar Weeks',
      dataKey: 'weeks',
      Cell: AWRWeeksRenderer
    }
  ];

  const data = [
    { position: 'Bartender', client: 'O2 Arena', weeks: 8 },
    { position: 'Waiter', client: 'Anfield', weeks: 13 },
    { position: 'Picker Packer', client: 'Ryder', weeks: 3 }
  ];

  return (
    <RootWrapper>
      <RootContainer>
        <AccordionSummaryContainer>
          <Header2> {t('awr')} </Header2>
        </AccordionSummaryContainer>
        <Table columns={columns} data={data} />
      </RootContainer>
    </RootWrapper>
  );
};

export default React.memo(EmployeeWorkingTimeDirective);
